<!--
* @FileDescription: 管理后台顶部
* @Author: Rocky
* @Date: 2020-12-25
* @LastEditors: Rocky
* @LastEditTime: 2020-12-25
-->
<template>
  <div id="app-header" style="height: 70px;">
    <el-row class="app-btns">
      <el-col :span="12" style="display: flex;">
        <ul style="padding: 0%;margin: 10px 0px;">
          <li style="list-style-type: none;">
            <span style="color: #fff; font-size: 24px;">{{ proName }}</span>
            <br/>
            <span style="color: #fff; font-size: 12px;">{{ proNameEn }}</span>
          </li>
        </ul>
        <ul style="padding: 0%;margin: 10px 0px;">
          <!-- <li style="list-style-type: none; text-align: center;" @click="cut">
            <span style="color: #fff; font-size: 22px;"><i class="el-icon-refresh"></i></span>
            <br/>
            <span style="color: #fff; font-size: 16px;">切换平台</span>
          </li> -->
        </ul>
      </el-col>
      <!-- <el-col class="app-logo" :span="10">
        <img src="@/../static/img/logo.png" />
      </el-col> -->
      <!-- <el-col class="app-links" :span="7">
        <ul>
          <li v-for="(item, index) in assets.appLinks" :key="index"
          @click="goMain(index)">
            <i :class="item.icon"></i>
            <span>{{ item.text }}</span>
            <span>{{ appLinkData[item.id] }}</span>
          </li>
        </ul>
      </el-col> -->
      <el-col class="app-btns" :span="6" :offset="6">
        <div style="text-align: right;">
          <ul>
            <!-- <li class="align_left">
              <i class="el-icon-mobile-phone"></i>
              <span>{{formData.log_username}}</span>
              <br/>
              <i class="el-icon-user"></i>
              <span style="color: #fff;">{{formData.log_name}}</span>
            </li> -->
            
            <li style="txt">
              <div @click="logouts" class="align_left">
                <i class="el-icon-s-platform"></i>
                <span v-if="!pingmu">大屏</span>
                <span v-if="pingmu">恢复</span>
              </div>
             <div @click="logout">
              <i class="el-icon-switch-button"></i>
              <span>退出</span>
             </div>
              <!-- <br/>
              <i @click="logout" class="el-icon-switch-button"></i>
              <span @click="logout">退出</span> -->
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>

    <!-- 对话框 -->
    <el-dialog title="修改密码" :visible.sync="showEditPassword" :show-close="false"
    width="30%" :modal="false" top="30vh" custom-class="app-alert-dialog">
      <el-form :model="formData" label-position="left" label-width="80px">
        <el-form-item label="原密码">
          <el-input size="small" v-model="formData.oriPw" placeholder="原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input size="small" v-model="formData.newPw" placeholder="新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input size="small" v-model="formData.rePw" placeholder="确认密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditPassword = false">取 消</el-button>
        <el-button type="primary" @click="doEditPassword">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DevicePixelRatio from '@/../static/plugins/devicePixelRatio.js';

export default {
  name: 'app-header',
  data () {
    return {
      pingmu: false,
      proName: this.GLOBAL.proName,
      proNameEn: this.GLOBAL.proNameEn,
      assets: {
        appLinks: [
          // { id: 'member', icon: 'el-icon-user-solid', text: '注册会员', path: '/user' },
          // { id: 'order', icon: 'el-icon-s-order', text: '今日发布', path: '/order' },
          // { id: 'driver', icon: 'el-icon-s-custom', text: '会员', path: '/driver' },
          // { id: 'waiting', icon: 'el-icon-s-cooperation', text: '活跃度', path: '/order' },
          // { id: 'ongoing', icon: 'el-icon-s-promotion', text: '发帖数', path: '/order' }
        ]
      },
      appLinkData: {
        'member': 100,
        'order': 100,
        'driver': 100,
        'waiting': 100,
        'ongoing': 100
      },
      formData: {
        oriPw: '',
        newPw: '',
        log_name: this.COOKIE.getCookie('log_name'),
        log_username: this.COOKIE.getCookie('log_username'),
        rePw: ''
      },
      showEditPassword: false
    }
  },
  methods: {
    /**
     * 跳转到 Main 中对应链接
     */
    goMain (index) {
      let that = this
      let linkPath = that.assets.appLinks[index].path
      if (linkPath !== this.$route.path) {
        that.$router.replace({
          path: linkPath,
          params: {}
        })
      }
    },
    /**
     * 打开对话框
     */
    openEditPassword () {
      let that = this
      that.showEditPassword = true
    },
    doEditPassword () {
      let that = this
    },
    /**
     * 登陆验证
     */
     LoginVerification () {
      let that = this
      if (that.COOKIE.getCookie('log_name') === ''  || that.COOKIE.getCookie('log_name') === undefined){
        that.logout()
      }
    },
    /**
     * 验证 uid
     */
     verifyLogin () {
      let that = this
      let uid = that.COOKIE.getCookie('uid')
      let token = that.COOKIE.getCookie('token')
      if (uid !== '' && token !== '') {
        that.isLogin = true
      } else {
        that.logout()
        that.isLogin = false
      }
    },
    /**
     * 登出
     */
    logout () {
      this.COOKIE.clearCookie('uid')
      this.COOKIE.clearCookie('token')
      location.reload()
    },
    /**
     * 大屏
     */
     logouts () {
      let that = this
      if(that.pingmu){
        DevicePixelRatio.init(1)
        that.pingmu = false
      }else{
        DevicePixelRatio.init(1.25)
        that.pingmu = true
      }
    },
    cut(){
      let that = this
      console.log(that.COOKIE.getCookie('isCut'))
      if ('sidebarOutItem' === that.COOKIE.getCookie('isCut')){
        that.COOKIE.setCookie('isCut', "sidebarMchItem", 7)
        this.$router.replace({path:'/'})// 跳转页面 传参
        that.COOKIE.setCookie('path', '/', 7)
      } else {
        that.COOKIE.setCookie('isCut', "sidebarOutItem", 7)
        this.$router.replace({path:'/banner'})// 跳转页面 传参
        that.COOKIE.setCookie('path', '/banner', 7)
      }
      that.cutName()
      // that.COOKIE.setCookie('path', '/', 7)
      // that.$router.replace({path:'/'})// 跳转页面 传参
      // location.reload()
    },
    cutName(){
      let that = this
      if ('sidebarOutItem' === that.COOKIE.getCookie('isCut')){
        that.proName = '新民市跨境进出口供应链平台'
        that.proNameEn = 'EXPORT MANAGEMENT SYSTEM'
      } else {
        that.proName = this.GLOBAL.proName
        that.proNameEn = this.GLOBAL.proNameEn
      }
    }
  },
  mounted () {
    // 登陆验证
    // this.LoginVerification()
    this.verifyLogin()
    this.cutName()
    // this.cut()
   
  }
}
</script>

<style scoped>
.el-row {
  margin: 0%;
}
.li{
  list-style-type: none;
}
.app-logo {
  position: relative;
  left: -15px;
  /* top: -5px; */
}
.app-links ul,
.app-btns ul {
  list-style: none;
  padding: 6px;
}
.app-btns li,
.app-links li {
  display: inline-block;
  margin-right: 15px;
  cursor: pointer;
}
.app-links li i {
  font-size: 17px;
  color: #494949;
  position: relative;
  top: 1px;
}
.app-links li span:nth-child(2),
.app-btns li {
  color: #ffffff;
}
.app-links li span:last-child {
  color: #a8a8a8;
}
.app-links li:hover span:nth-child(2) {
  color: #deefff;
}
.app-links li:hover i,
.app-links li:hover span:last-child {
  color: #deefff;
}
.align_left{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/frame/Header.vue